/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { of, throwError } from "rxjs";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	METRIC_OVERVIEW_RESPONSE,
	SITE_METRIC_DATA_RESPONSE,
	SITE_SERIE_RESPONSE
} from "./dashboard-data-centers.db";

export class DashboardDataCenters {
	public static getUserSiteList() {
		return of(SITE_SERIE_RESPONSE);
	}

	public static getMetricOverview() {
		return of(METRIC_OVERVIEW_RESPONSE);
	}

	public static getUserSiteMetricData(options: HttpRequestOptions) {
		const siteId = DashboardDataCenters._extractParamValue(options.params, "siteId");

		if (!siteId) {
			console.error("Missing siteId parameter");
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						this.constructor.name,
						this.getUserSiteMetricData.name
					)
			);
		}

		return of(SITE_METRIC_DATA_RESPONSE[Number(siteId)] ?? []);
	}

	private static _extractParamValue(
		params: HttpRequestOptions["params"],
		key: string
	): string | null {
		if (!params) {
			return null;
		}

		if (params instanceof HttpParams) {
			return params.get(key);
		}

		const rawValue = (params as Record<string, unknown>)[key];

		if (Array.isArray(rawValue)) {
			const first = rawValue[0];
			return first !== undefined ? String(first) : null;
		}

		if (typeof rawValue === "number" || typeof rawValue === "boolean") {
			return String(rawValue);
		}

		return (rawValue as string | undefined) ?? null;
	}
}
